<template>
    <div>
        <el-input
            v-if="mode == 'edit'"
            :ref="reference"
            v-model="currentValue"
            :placeholder="prop.defaultValue"
            :minlength="parseInt(prop.min)"
            :maxlength="parseInt(prop.max)"
        >
        </el-input>
        <p v-else>
            {{ currentValue }}
        </p>
    </div>
</template>

<script>
import CfMixin from '../../../mixins/CustomfieldInputsMixins';
import { deepEqual } from 'Helpers/deepEqual';
export default {
    mixins: [CfMixin],
    emits: ['update:modelValue'],

    data() {
        return {
            localValue: this.value,
            currentValue: '',
        };
    },

    watch: {
        currentValue(newValue, oldValue) {
            if (!deepEqual(newValue, oldValue)) {
                this.$emit('update:modelValue', { ...this.localValue, ['textValue']: newValue });
            }
        },
        value: {
            handler: function (newValue, oldValue) {
                if (!deepEqual(newValue, oldValue)) {
                    this.localValue = newValue;
                    this.currentValue = newValue.textValue;
                }
            },
            deep: true,
        },
    },

    created() {
        if (!this.localValue) {
            this.localValue = JSON.parse(JSON.stringify(this.templateData));
            this.currentValue = this.prop.defaultValue;
        } else {
            this.currentValue = this.value.textValue;
        }
    },

    methods: {
        checkParams(newValue) {
            let valid = true;
            valid = this.checkMinMaxParams(newValue);
            return valid;
        },
    },
};
</script>
